import { SkillDto } from '@app/core/model/skill-dto';

import { UUID } from '@app/_api/identifyable';

export class TreeFilterUtil {
  static searchSkill(searchTerm: string, allSkills: SkillDto[]): SkillDto | undefined {
    const properSkills = allSkills.filter(s => !!s.parentId);
    return properSkills.find(s => s.title.toLowerCase() === searchTerm.toLowerCase());
  }

  static findBranch(skill: SkillDto, allSkillsMap: Record<UUID, SkillDto>): UUID {
    const findFirstLevelParentRecursive = (child: SkillDto) => {
      if (!child.parentId) return child;
      const parent = allSkillsMap[child.parentId];
      if (!parent.parentId) return child;
      return findFirstLevelParentRecursive(parent);
    };
    return findFirstLevelParentRecursive(skill).id;
  }

  static readonly filterTitle = (title: string) => title?.replaceAll(/[+\-/\\(){}[\]<>!§$%&=?*#€¿_".,:; ]/g, '').toLowerCase();
}
